// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"601":"5bf16683","967":"5bf16683"}[chunkId] + ".chunk.css";
};